// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CartCheckoutController from "./cart_checkout_controller"
application.register("cart-checkout", CartCheckoutController)

import CartController from "./cart_controller"
application.register("cart", CartController)

import CartSuccessController from "./cart_success_controller"
application.register("cart-success", CartSuccessController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PhotoSortController from "./photo_sort_controller"
application.register("photo-sort", PhotoSortController)

import ProductGalleryController from "./product_gallery_controller"
application.register("product-gallery", ProductGalleryController)

import QuantityController from "./quantity_controller"
application.register("quantity", QuantityController)

import StoreController from "./store_controller"
application.register("store", StoreController)

import StripeCheckoutController from "./stripe_checkout_controller"
application.register("stripe-checkout", StripeCheckoutController)

import VideoPlayerController from "./video_player_controller"
application.register("video-player", VideoPlayerController)

import PrimaryNavController from "./primary_nav_controller"
application.register("primary-nav", PrimaryNavController)
